import { Card, CardHeader, CardTitle } from '@/components'

import { Ordem } from '../entities/ordem'
import { OrdemDetailsCard_Track } from './ordem-details-card.track'
import { ItemField } from './utils/item-field'

export function OrdemDetailsCard({ ordem }: { ordem: Ordem }) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Detalhes da ordem</CardTitle>
      </CardHeader>

      <div className="space-y-4">
        <div className="grid grid-cols-2 gap-4">
          <ItemField label="Nº Ordem">
            <span className="font-bold">
              {ordem.id.toString().padStart(4, '0')}
            </span>
          </ItemField>
          <ItemField label="Aberta em">
            {ordem.abertaEm.toLocaleDateString()}
          </ItemField>
          <ItemField label="Aprovada em">
            {ordem.aprovadoEm?.toLocaleDateString() ?? 'Não informado'}
          </ItemField>
          <ItemField label="Data de entrega">
            {ordem.entregaEm?.toLocaleDateString() ?? 'Não informado'}
          </ItemField>
        </div>
        <OrdemDetailsCard_Track ordem={ordem} />
        <ItemField label="Defeito reclamado">
          {ordem.defeitoReclamado ?? 'Não informado'}
        </ItemField>
        <ItemField label="Defeito constatado">
          {ordem.defeitoConstatado ?? 'Não informado'}
        </ItemField>
        <ItemField label="Condição de pagamento">
          {ordem.condicaoPgto ?? 'Não informado'}
        </ItemField>
        {/* TODO: campo de observação */}
        {/* <ItemField label="Obervações">
          {ordem.condicaoPgto ?? 'Não informado'}
        </ItemField> */}
      </div>
    </Card>
  )
}
